import handleMethod from '../Utils/APIutils/handleMethod';

class HeatmapAPI {
  async getById(id) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/heatmaps/${id}` });
  }

  async list(page = 1, itemsPerPage = 20) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/heatmaps?page=${page}&itemsPerPage=${itemsPerPage}` });
  }

  async getByStore(storeId, limit = 50) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/heatmaps/by-store/${storeId}?limit=${limit}` });
  }

  async getRecentByDevice(deviceId, limit = 10) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/heatmaps/device/${deviceId}/recent?limit=${limit}` });
  }

  async getByDateRange(deviceId, startDate, endDate) {
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/heatmaps/device/${deviceId}/range?startDate=${from}&endDate=${to}` });
  }

  async getUnprocessed(limit = 100) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/heatmaps/unprocessed?limit=${limit}` });
  }

  async resetHeatmap(deviceId) {
    return handleMethod({ type: 'POST', method: `api/gatewaycontagem/heatmaps/device/${deviceId}/reset-heatmap` });
  }

  async getTemporalSummary(deviceId, startDate = null, endDate = null, storeId = null) {
    const params = new URLSearchParams();
    if (startDate) {
      params.append('startDate', typeof startDate === 'string' ? startDate : startDate.toISOString());
    }
    if (endDate) {
      params.append('endDate', typeof endDate === 'string' ? endDate : endDate.toISOString());
    }
    if (storeId) {
      params.append('storeId', storeId);
    }
    const queryString = params.toString() ? `?${params.toString()}` : '';
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/heatmaps/device/${deviceId}/temporal-summary${queryString}` });
  }
}

export const heatmapAPI = new HeatmapAPI();
